import React from "react";
import s from "../Default.module.css"
import ToNews from "../../News/ToNews";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import parse from "html-react-parser";

const SingleNewsPage = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [news, setNews] = useState({
      date: "2000-01-01",
      Header: "loading...",
      img: "",
      description: "loading...",
      images: [],
      news_text: "loading...",
      ref: "",
      text: "loading..."
    });
    const [error, setError] = useState(null);

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [id]);

    useEffect(() => {
      const loadInfo = async () => {
        try {
          const res = await axios.get("https://fcprc.ru/api/main");
          const newsData = Array.isArray(res.data) ? res.data : Object.values(res.data);
          
          const foundNews = newsData.find(item => 
            item.ref === `/post/${id}` || 
            item.ref === `post/${id}` ||
            item.id === parseInt(id)
          );
          
          console.log("Searching for news with id:", id, "Found:", foundNews);
          
          if (foundNews) {
            setNews({
              date: foundNews.date || "2000-01-01",
              Header: foundNews.Header || foundNews.header || foundNews.text || "loading...",
              img: foundNews.img || "",
              description: foundNews.description || "loading...",
              images: foundNews.images || [],
              news_text: foundNews.news_text || foundNews.text || "loading...",
              ref: foundNews.ref || "",
              text: foundNews.text || "loading..."
            });
            setError(null);
          } else {
            console.error("News not found for id:", id);
            setError("Новость не найдена");
          }
        } catch (e) {
          console.error("Error loading news:", e);
          setError("Ошибка при загрузке новости");
        } finally {
          setLoading(false);
        }
      };
      loadInfo();
    }, [id]);

    if (loading) {
      return <div>Загрузка...</div>;
    }
    
    if (error) {
      return <div className={s.page}>
        <h2 style={{
            fontWeight: "normal",
            marginTop: "50px",
            color: "#3a4663",
            textAlign: "left",
            maxWidth: "1100px",
            margin: "40px auto",
            fontFamily: "Proxima Nova Lt"
        }}>
            {error}
        </h2>
        <ToNews />
      </div>;
    }

    return <div className={s.page}>
        <h2 style={{
            fontWeight: "normal",
            marginTop: "50px",
            color: "#3a4663",
            textAlign: "left",
            maxWidth: "1100px",
            margin: "40px auto",
            fontFamily: "Proxima Nova Lt"
        }}>
            {news.Header}
        </h2>
        {news.img && (
          <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
              <img 
                src={news.img} 
                alt={news.Header} 
                style={{ maxWidth: "100%", height: "auto" }}
              />
          </div>
        )}
        <div style={{ 
          fontFamily: "Proxima Nova Lt",
          maxWidth: "1100px",
          margin: "20px auto",
          lineHeight: "1.6"
        }}>
            {parse(news.news_text)}
        </div>
        {news.images && news.images.length > 0 && news.images.map((image, index) => (
          <div key={index} style={{ maxWidth: "1100px", margin: "20px auto" }}>
            <img 
              src={image.image} 
              alt={`News image ${index + 1}`} 
              style={{ maxWidth: "100%", height: "auto" }}
            />
          </div>
        ))}
        <ToNews />
    </div>
}

export default SingleNewsPage;